module.exports = __webpack_public_path__ + "img/6-m.0d47fd06.jpg";